export const PORTFOLIO_DATA_PENDING = "PORTFOLIO_DATA_PENDING";
export const PORTFOLIO_DATA_SUCCESS = "PORTFOLIO_DATA_SUCCESS";
export const PORTFOLIO_DATA_FAIL = "PORTFOLIO_DATA_FAIL";
export const PORTFOLIO_ALL_DATA_PENDING = "PORTFOLIO_ALL_DATA_PENDING";
export const PORTFOLIO_ALL_DATA_SUCCESS = "PORTFOLIO_ALL_DATA_SUCCESS";
export const PORTFOLIO_ALL_DATA_FAIL = "PORTFOLIO_ALL_DATA_FAIL";
export const FUNDCATEGORYNEW_ALL_DATA_PENDING = "FUNDCATEGORYNEW_ALL_DATA_PENDING";
export const FUNDCATEGORYNEW_ALL_DATA_SUCCESS = "FUNDCATEGORYNEW_ALL_DATA_SUCCESS";
export const FUNDCATEGORYNEW_ALL_DATA_FAIL = "FUNDCATEGORYNEW_ALL_DATA_FAIL";
export const PORTFOLIO_DATA_MOH = "PORTFOLIO_DATA_MOH";
export const PORTFOLIO_PAGE = "PORTFOLIO_PAGE";
export const PORTFOLIO_BLOCK = "PORTFOLIO_BLOCK";
export const PORTFOLIO_BANNER = "PORTFOLIO_BANNER";

export const ZBF_FOLIO_SUCCESS = "ZBF_FOLIO_SUCCESS";
export const ZBF_FOLIO_FAIL = "ZBF_FOLIO_FAIL";
export const NEW_FUND_SET = "NEW_FUND_SET";
// existing constiner

export const EXISTING_BOX = "EXISTING_BOX";

// order book

export const ORDERBOOK_PENDING = "ORDERBOOK_PENDING";
export const ORDERBOOK_SUCCESS = "ORDERBOOK_SUCCESS";
export const ORDERBOOK_FAIL = "ORDERBOOK_FAIL";

// folio Desc
export const FOLIODESC_PENDING = "FOLIODESC_PENDING";
export const FOLIODESC_SUCCESS = "FOLIODESC_SUCCESS";
export const FOLIODESC_FAIL = "FOLIODESC_FAIL";

// end folio Desc

export const PORTFOLIO_SINGLE = "PORTFOLIO_SINGLE";

// singleSchemeCode
export const PORTFOLIO_SCHEME_CODE = "PORTFOLIO_SCHEME_CODE";

// select single folio

export const PORTFOLIO_FOLIO_CODE = "PORTFOLIO_FOLIO_CODE";

export const PORTFOLIO_HOLDING_TYPE = "PORTFOLIO_HOLDING_TYPE";

// single bank
export const PORTFOLIO_SELECTED_BANK = "PORTFOLIO_SELECTED_BANK";

export const ADD_TO_CART_PENDING = "ADD_TO_CART_PENDING";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE";

export const SINGLE_CART_DATA = "SINGLE_CART_DATA";

export const SIPDASHBOARD_PENDING = "SIPDASHBOARD_PENDING";
export const SIPDASHBOARD_SUCCESS = "SIPDASHBOARD_SUCCESS";
export const SIPDASHBOARD_FAILURE = "SIPDASHBOARD_FAILURE";

export const SWPDASHBOARD_PENDING = "SWPDASHBOARD_PENDING";
export const SWPDASHBOARD_SUCCESS = "SWPDASHBOARD_SUCCESS";
export const SWPDASHBOARD_FAILURE = "SWPDASHBOARD_FAILURE";

export const STPDASHBOARD_PENDING = "STPDASHBOARD_PENDING";
export const STPDASHBOARD_SUCCESS = "STPDASHBOARD_SUCCESS";
export const STPDASHBOARD_FAILURE = "STPDASHBOARD_FAILURE";

export const FILL_FOLIO_SCHEME = "FILL_FOLIO_SCHEME";

// action

export const PORTFOLIO_SCHEME_ACTION = "PORTFOLIO_SCHEME_ACTION";

// action category

export const CAT_SAVE_SCHEMECODE = "CAT_SAVE_SCHEMECODE";
export const CAT_SAVE_CARTID = "CAT_SAVE_CARTID";
export const IS_MANDATE = "IS_MANDATE";

// cart
export const GET_CART_PENDING = "GET_CART_PENDING";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
export const GET_CART_FAILURE = "GET_CART_FAILURE";

export const SIP_AMOUNT = "SIP_AMOUNT";
export const ISIPCHK = "ISIPCHK";
export const ISMANDATE = "ISMANDATE";
export const ISMANDATEAVAIL = "ISMANDATEAVAIL";
export const ISTWOPAYMENT = "ISTWOPAYMENT";
export const LUM_AMOUNT = "LUM_AMOUNT";
export const ISIP_AMOUNT = "ISIP_AMOUNT";
export const CART_ID = "CART_ID";
export const CART_ARRAY = "CART_ARRAY";
export const BANK_NAME = "BANK_NAME";
export const BANK_NUMBER = "BANK_NUMBER";
export const PG = "PG";
export const BUCKET_ID = "BUCKET_ID";
export const IFSC = "IFSC";
export const RAZORPAYKEY = "RAZORPAYKEY";
export const CHEQUE_MODE = "CHEQUE_MODE";
export const PAYMENT_MODE = "PAYMENT_MODE";
export const ISIP_TYPE = "ISIP_TYPE";
export const LUMP_TYPE = "LUMP_TYPE";
export const SIP_TYPE = "SIP_TYPE";
export const UTR_NO = "UTR_NO";
export const BROKER_CART_ID = "BROKER_CART_ID";
export const BROKER_DIS_CART_ID = "BROKER_DIS_CART_ID";
export const CART_ROW_DATA = "CART_ROW_DATA";

export const NEW_USER_DATA = "NEW_USER_DATA";

export const SAVE_CART_BOX = "SAVE_CART_BOX";
export const DEL_CART_BOX = "DEL_CART_BOX";
export const RESET_CART_BOX = "RESET_CART_BOX";
export const REPLACE_CART_BOX = "REPLACE_CART_BOX";
export const SAVE_OPTION_CODE = "SAVE_OPTION_CODE";

//start cart order review 
export const SAVE_CART_ORDER_REVIEW_DATA = "SAVE_CART_ORDER_REVIEW_DATA";
export const DEL_CART_ORDER_REVIEW_DATA = "DEL_CART_ORDER_REVIEW_DATA";
export const RESET_CART_ORDER_REVIEW_DATA = "RESET_CART_ORDER_REVIEW_DATA";
export const REPLACE_CART_ORDER_REVIEW_DATA = "REPLACE_CART_ORDER_REVIEW_DATA";
//end cart order review 

export const PUSH_DIST_CARTID_REG_BROKER = "PUSH_DIST_CARTID_REG_BROKER";
export const PUSH_DIST_CARTID_DIR_BROKER = "PUSH_DIST_CARTID_DIR_BROKER";

// cart page validation

export const SHOW_BANK_ERR = "SHOW_BANK_ERR";
export const SHOW_MANDATE_ERR = "SHOW_MANDATE_ERR";
export const SHOW_UTRNO_ERR = "SHOW_UTRNO_ERR";

export const UPDATE_GUEST_MENU = "UPDATE_GUEST_MENU";
export const UPDATE_GUEST_TYPE = "UPDATE_GUEST_TYPE";

export const SET_DIST_FLAG = "SET_DIST_FLAG";

export const GET_ALL_FOLIOS = "GET_ALL_FOLIOS";

export const PROCESS_FOLIOS_FOR_SELECT = "PROCESS_FOLIOS_FOR_SELECT";

// active Investor

export const ACTIVE_INVESTOR = "ACTIVE_INVESTOR";
export const ACTIVE_PANDROPDOWN = "ACTIVE_PANDROPDOWN";

// local action

export const SAVE_CVL_DATA = "SAVE_CVL_DATA";

export const RESET_SIP_DASHBOARD = "RESET_SIP_DASHBOARD";
export const RESET_GUEST_MENU = "RESET_GUEST_MENU";

// auth

export const OB_FOLIOHOLDING_DATA = "OB_FOLIOHOLDING_DATA";

export const PAN_AGAIN_FOLIO = "PAN_AGAIN_FOLIO";
export const FOLIO_SELECTION_CART = "FOLIO_SELECTION_CART";
export const RESET_PAYMENT_MODE = "RESET_PAYMENT_MODE";

export const FOLIO_KARY_PENDING = "FOLIO_KARY_PENDING";
export const FOLIO_KARY_SUCCESS = "FOLIO_KARY_SUCCESS";
export const FOLIO_KARY_FAILED = "FOLIO_KARY_FAILED";

export const GET_CART_COUNT = "GET_CART_COUNT";
export const GET_CART_COUNT_SUCCESS = "GET_CART_COUNT_SUCCESS";
export const GET_CART_COUNT_FAILURE = "GET_CART_COUNT_FAILURE";

export const CART_TOTAL_AMOUNT = "CART_TOTAL_AMOUNT";
export const CART_TOTAL_AMOUNT_SUCCESS = "CART_TOTAL_AMOUNT_SUCCESS";
export const CART_TOTAL_AMOUNT_FAILURE = "CART_TOTAL_AMOUNT_FAILURE";

// bucketID

export const SAVE_BUCKET_ID = "SAVE_BUCKET_ID";
export const MANDATE_NAME = "MANDATE_NAME"
export const MANDATE_NUMBER = "MANDATE_NUMBER"
export const MANDATE_IHNO = "MANDATE_IHNO"

export const RIStatus = "RIStatus";

export const SELECTED_RI_DATA = "SELECTED_RI_DATA";
export const ALL_FUND_DETAILS = "ALL_FUND_DETAILS";
export const SET_UPI_MANDATE_FORM_DATA = "SET_UPI_MANDATE_FORM_DATA";
export const SET_MANDATE_SUB_MENU_SELECTED = "SET_MANDATE_SUB_MENU_SELECTED";


